module.exports = __webpack_public_path__ + "static/media/cases_3d_04a.b4fa45b0.jpg";